<script setup>
import { ref } from "vue";
import { truncateString } from "@/utils/utils";

const props = defineProps({
  imageObj: { type: Object, required: true },
  width: { type: String, default: "200px" }
});

const showModal = ref(false);

const closeModal = () => {
  showModal.value = false;
};
</script>

<template>
  <div
    class="media-url"
    :style="{ width: props.width, height: props.width }"
    @click="showModal = true"
  >
    <div class="image-cover">
      {{
        truncateString(
          imageObj.media_name ? imageObj.media_name : imageObj.url,
          12
        )
      }}
    </div>
    <img
      v-if="imageObj.media_type?.startsWith('image/')"
      :src="imageObj.url"
      class="thumbnail-image"
      :style="{ width: props.width, height: props.width }"
    />
  </div>
  <div v-if="showModal" class="image-modal" @click.self="closeModal">
    <icon class="modal-exit" icon="close" @click="closeModal" />
    <img :src="imageObj.url" alt="Full size" />
  </div>
</template>

<style lang="scss" scoped>
// $--image-thumbnail-width: 200px;

.media-url {
  // border: solid 2px black;
  position: relative;
  // width: $--image-thumbnail-width;
  aspect-ratio: 1;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition:
    transform 0.2s,
    box-shadow 0.2s;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

    .image-cover {
      opacity: 1;
    }
  }

  .image-cover {
    position: absolute;
    top: 6px;
    right: 6px;
    padding: 2px 10px;
    border-radius: 15px;
    font-size: $font-size-xs;
    color: $neutral-400;
    background: $neutral-150;
    opacity: 0;
    transition: opacity 0.2s ease;
    pointer-events: none;
  }

  .thumbnail-image {
    // width: $--image-thumbnail-width;
    aspect-ratio: 1;
    object-fit: cover;
    object-position: center;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

.image-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: black;
  color: white;
  z-index: 50;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .modal-exit {
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    height: 50px;
    width: 50px;
    cursor: pointer;
    z-index: 100;
  }

  img {
    max-width: 90%;
    max-height: 90%;
    object-fit: contain;
    border-radius: 6px;
  }
}
</style>
